import {
  Grid,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  FormControl,
  Autocomplete,
  RadioGroup,
  Divider,
  TextField,
  CardMedia,
  Button,
  FormHelperText,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import clsx from "clsx";
import Configs from "../../constants/Configs";
import DialogError from "../../components/CustomDialog/DialogWait";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  callChoice,
  addWarterMarker,
  setHash,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { fomaterBankNumber, fomatterNumber } from "../../utils/formatter";
import GlobalApi from "../../utils/GlobalApi";
import { isEmpty } from "lodash";
import { loadImage } from "canvas";
import qs from "qs";
import { styled } from "@mui/system";
import moment from "moment";
const Input = styled("input")({
  display: "none",
});
const useStyle = makeStyles((theme) => ({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  btnRadioMain: {
    position: "relative",
    color: "var(--primary)",
    margin: "auto",
    marginBottom: "16px",
    width: "90%",
    boxShadow: "2px 3px 6px 0px #ccc",
    borderRadius: "6px",
    padding: "0 4%",
  },
  BtnRadioAtsApply: {
    width: "100%",
    fontFamily: "DB Heavent",
    "& label": {
      display: "flex",
      width: "100%",
      minHeight: "60px",
      margin: "auto",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      "& span.MuiRadio-root": {
        fontSize: "20px !important",
        padding: "0",
      },
      "& span.MuiTypography-root": {
        fontSize: "20px !important",
        marginLeft: "46px",
      },
    },
    "& .radioOther span.MuiTypography-root": {
      marginLeft: "4px",
    },
  },
  iconBank: {
    position: "absolute",
    width: "34px",
    left: "11px",
    top: "12px",
    pointerEvents: "none",
  },
  subList: {
    color: "var(--black)",
    fontSize: "18px",
    padding: "10px 0",
    "& .li": {
      display: "flex",
      "& svg": {
        fontSize: "8px",
        marginRight: "8px",
        marginTop: "7px",
      },
    },
  },
  borderCustom: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px dashed var(--lemon)",
    borderRadius: "4px",
    width: "90%",
    margin: "auto",
    color: "var(--primary)",
  },
  centerIcon: {
    position: "absolute",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "DB Heavent",
    fontSize: "18px",
    pointerEvents: "none",
  },
  imgSign: {
    display: "block",
    width: "100%",
    margin: "auto",
    minHeight: "166px",
  },
  imgPhoto: {
    width: "16%",
  },
  customUpLoad: {
    position: "absolute",
    opacity: "0",
    width: "100%",
    height: "100%",
  },
}));
const header = {
  headers: {
    // "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const AtsApply = (props) => {
  const HeaderManp = getData("HeaderManp") ? getData("HeaderManp") : "";
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const checkuserinfo = getData("checkuserinfo")
    ? getData("checkuserinfo")
    : "";
  const classes = useStyle();
  const [isCheck, setIscheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const [valueRadio, setValueRadio] = useState("");
  const [BankId, setBankId] = useState({});
  const [textAccount, setTextAccount] = useState("");
  const [textNumberBank, setTextNumberBank] = useState("");
  const [imgAccount, setImgAccount] = useState("");
  const [imgAccountWithWaterMark, setImgAccountWithWaterMark] = useState("");
  const [listBank, setListBank] = useState("");
  const [errorText, setErrorText] = useState({
    textNumberBank: "",
  });
  let stampUpload = getData("stampUpload")
    ? getData("stampUpload")
    : {
        uploadImage: false,
        eSignature: false,
        uploadImageBookBank: false,
      };
  const [jumpPage, setJumpPage] = useState(false);
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  const [isModalATS, setIsModalATS] = useState(false);
  const { nameTH, nameEN, middlenameTH, middlenameEN, lastnameTH, lastnameEN } =
    idc;
  const [massage, setMassage] = useState("");
  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const callBank = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/bank`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setListBank(data);
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleChangeBank = (e, value) => {
    if (!isEmpty(value)) {
      setBankId(value);
    } else {
      setBankId({});
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        const name =
          lang === "th"
            ? nameTH +
              " " +
              (middlenameTH !== "" ? middlenameTH : "") +
              " " +
              lastnameTH
            : nameEN +
              " " +
              (middlenameEN !== "" ? middlenameEN : "") +
              " " +
              lastnameEN;
        setTextAccount(name);
        if (listBank === "") {
          callBank();
        }
        clearData("requestBankMapping");
      }
    });
  }, []);
  const handleChangeRadio = (e) => {
    setValueRadio(e.target.value);
    if (e.target.value === "99") {
      if (listBank === "") {
        callBank();
      }
    } else {
      // console.log(e.target.value);
    }
  };
  const textAccountChange = (val) => {
    setTextAccount(val);
  };
  const textNumberBankChange = (val) => {
    if (val.length === 10) {
      setErrorText({
        ...errorText,
        textNumberBank: "",
      });
    } else {
      setErrorText({
        ...errorText,
        textNumberBank: "กรุณากรอกเลขบัญชีให้ครบ 10 หลัก",
      });
    }
    setTextNumberBank(fomatterNumber(val));
  };
  const upLoadOnChange = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      return;
    }
    setImgAccount("");
    setImgAccountWithWaterMark("");
    if (parseFloat(file.size / 1024 / 1024) > 10) {
      setModalErrorTitle(translations?.[lang]?.snapidcard?.alert_upload?.title);
      setModalErrorDes(translations?.[lang]?.snapidcard?.alert_upload?.massage);
      setIsModalError(true);
    } else {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      let reader = new FileReader();
      var fileTypes = ["jpg", "jpeg", "png"];
      var extension = e.target.files[0].name.split(".").pop().toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1; //is extension in acceptable types

      if (isSuccess) {
        reader.addEventListener(
          "load",
          async function () {
            let imgSrc = reader.result;
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imgMark = new Image();
            imgMark.src = "/images/waterMark2.png?v=4";
            await loadImage(imgSrc)
              .then(async (image) => {
                const maxW = 1200;
                const maxH = 1200;
                const iw = image.width;
                const ih = image.height;
                const scale = Math.min(maxW / iw, maxH / ih);
                const iwScaled = iw * scale;
                const ihScaled = ih * scale;
                canvas.width = iwScaled;
                canvas.height = ihScaled;

                ctx.fillStyle = "rgb(255, 255, 255)";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.drawImage(image, 0, 0, iwScaled, ihScaled);
                //  ctx.drawImage(imgMark, 0, 0, iwScaled, ihScaled);
                storeData(
                  "uploadImageBookBank",
                  canvas.toDataURL("image/jpeg", 0.5),
                );
                setImgAccount(canvas.toDataURL("image/jpeg", 0.5));
                setImgAccountWithWaterMark(canvas.toDataURL("image/jpeg", 0.5));
                await setIsLoading(false);
              })
              .catch((e) => {
                setIsLoading(false);
                return;
              });
          },
          false,
        );
        if (file) {
          reader.readAsDataURL(file);
        }
      } else {
        setIsModalError(true);
        setModalErrorTitle(
          translations?.[lang]?.snapidcard?.alert_upload_file_type?.title,
        );
        setModalErrorDes(
          translations?.[lang]?.snapidcard?.alert_upload_file_type?.massage,
        );
      }
    }
  };
  const saveImage = async () => {
    const uploadImage = imgAccountWithWaterMark ? imgAccountWithWaterMark : "";
    const uploadImage_str = uploadImage.split("data:image/jpeg;base64,");
    const hashData = setHash(uploadImage);
    const watermark_image = await addWarterMarker(uploadImage, false, "");
    try {
      var postData = {
        head_token,
        base64: uploadImage_str[1],
        type: "data:image/jpeg;base64,",
        key: "uploadImageBookBank",
        hash: hashData,
        watermark_image: watermark_image,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/upload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          //setIsLoading(false);
          stampUpload.uploadImageBookBank = true;
          await storeData("stampUpload", stampUpload);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let error_txt = er?.data?.MsgDesc?.return_message
            ? er?.data?.MsgDesc?.return_message
            : "";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
              error_txt !==
            ""
              ? error_txt
              : getData("api_error")?.message + ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      let title = "เกิดข้อผิดพลาด";
      let error_txt = error?.data?.MsgDesc?.return_message
        ? error?.data?.MsgDesc?.return_message
        : "";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + error_txt !==
        ""
          ? error_txt
          : getData("api_error")?.message + ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
    }
    return;
  };
  const checkOthorValidate = () => {
    return (
      valueRadio === "99" &&
      !(
        !isEmpty(BankId) &&
        textAccount &&
        textNumberBank.length === 10 &&
        imgAccount
      )
    );
  };
  const checkATS = async (requestBankMapping) => {
    setIsLoading(true);
    try {
      const data = {
        head_token: head_token,
        channel: "OA",
        status: "success",
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/ats_form/selbyhead`,
        data,
        header,
      )
        .then(async (res) => {
          if (res?.data?.Data) {
            const dataATS = res?.data?.Data?.[0];

            const f7_bank_ats = await listBank.find((o) =>
              o.Id.includes(requestBankMapping?.bankID),
            );
            storeData("f7_bank_ats", f7_bank_ats);
            const ats_data = {
              f7_isother: "0",
              add_account_json: [
                {
                  SAfba_Id: "0", //  fix เป็นค่า 0
                  SAfba_SAmbk_Id: requestBankMapping?.bankID, // "BankId"
                  SAfba_SAmbkb_Id: "", // "BranchId" เพิ่มใหม่ ส่งเป็นค่า 0
                  SAfba_SAmbkt_Id: "", // เลขidของ ประเภทบัญชี ส่งค่าว่าง
                  SAfba_AccountNo: dataATS?.AccountNo, // "BankAccountNo" “”:
                  SAfba_AccountName:
                    lang === "th"
                      ? nameTH +
                        " " +
                        (middlenameTH !== "" ? middlenameTH : "") +
                        " " +
                        lastnameTH
                      : nameEN +
                        " " +
                        (middlenameEN !== "" ? middlenameEN : "") +
                        " " +
                        lastnameEN,
                  SAfba_UseATS: "1", // ATSFlag ให้ตัดเงินด้วย ATS หรือไม่ใช่“1” ไม่ใช่“0”
                  SAfba_UseDividend: "0", // fix เป็นค่า 0
                },
              ],
            };
            storeData("f7_ats", ats_data);
            storeData("stamp_page", "SUMMARY");
            storeData("ats_from", res?.data?.Data);

            var last_stamp = JSON.stringify(await getAllStorage("SUMMARY"));
            try {
              await GlobalApi.post(
                `${Configs.baseAPIURL03}/form/bank_account/manp`,
                {
                  head_token: head_token,
                  f7_isother: ats_data.f7_isother,
                  add_account_json: ats_data.add_account_json,
                },
                header,
              )
                .then(async (res) => {
                  if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                    let mss =
                      res.data.Data[0].MsgDesc !== ""
                        ? res.data.Data[0].MsgDesc
                        : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                    let title = "เกิดข้อผิดพลาด";
                    clearData("f7_ats");
                    clearData("uploadImageBookBank");
                    setIsLoading(false);
                    setIsModalError(true);
                    setModalErrorTitle(title);
                    setModalErrorDes(mss);
                  } else {
                    try {
                      await GlobalApi.post(
                        `${Configs.baseAPIURL03}/form/comeback/manp`,
                        {
                          head_token: head_token,
                          last_stamp: last_stamp,
                          stamp_page: "SUMMARY",
                        },
                        header,
                      )
                        .then((ress) => {
                          setIsLoading(false);
                          if (ress?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                            clearData("f7_ats");
                            clearData("f7_bank_ats");
                            let mss =
                              ress.data.Data[0].MsgDesc !== ""
                                ? ress.data.Data[0].MsgDesc
                                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                            let title = "เกิดข้อผิดพลาด";
                            setIsLoading(false);
                            setIsModalError(true);
                            setModalErrorTitle(title);
                            setModalErrorDes(mss);
                          } else {
                            let date = moment(dataATS?.update_at?.date).format(
                              "DD/MM/YYYY",
                            );
                            let time = moment(dataATS?.update_at?.date).format(
                              "HH:mm",
                            );
                            let mss =
                              "เลขที่บัญชี " +
                              dataATS?.AccountNo +
                              "<br>เมื่อวันที่ " +
                              date +
                              "<br>เวลา " +
                              time +
                              " น.";
                            setIsModalATS(true);
                            setMassage(mss);
                          }
                        })
                        .catch((ee) => {
                          clearData("f7_ats");
                          clearData("f7_bank_ats");

                          setIsLoading(false);
                          let title = "เกิดข้อผิดพลาด";
                          let mss =
                            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                            getData("api_error")?.message +
                            ")";
                          setIsModalError(true);
                          setModalErrorTitle(title);
                          setModalErrorDes(mss);
                        });
                    } catch (e) {
                      clearData("f7_ats");
                      clearData("f7_bank_ats");
                      setIsLoading(false);
                      setIsModalError(true);
                    }
                  }
                })
                .catch((er) => {
                  clearData("f7_ats");
                  clearData("uploadImageBookBank");
                  setIsLoading(false);
                  let title = "เกิดข้อผิดพลาด";
                  let mss =
                    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                    getData("api_error")?.message +
                    ")";
                  setIsModalError(true);
                  setModalErrorTitle(title);
                  setModalErrorDes(mss);
                });
            } catch (error) {
              setIsLoading(false);
              setIsModalError(true);
            }
          } else {
            setIsLoading(false);
            await getAtsApi(requestBankMapping);
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const handleNext = async () => {
    if (valueRadio) {
      if (valueRadio === "99") {
        await saveComeback();
      } else {
        chooseAts(valueRadio);
      }
    } else {
    }
  };
  const chooseAts = async (e) => {
    const bankID = e;
    const token = HeaderManp.token;
    let bankIDKbank = listBank.find((o) => o.ThName.includes("กสิกร"));
    let bankIDScb = listBank.find((o) => o.ThName.includes("ไทยพาณิชย์"));
    const requestBankMapping = {
      0: {
        url: `${Configs.baseAPIURLATS}/scb/register_request`,
        param: {
          ats_card_id: checkuserinfo.cardId,
          token: token,
          redirect_url: `${Configs.baseURL}/ats_waiting`,
          channel: "OA",
        },
        bankCode: "scb",
        bankID: bankIDScb.Id,
      },
      1: {
        url: `${Configs.baseAPIURLATS}/kbank/register_request`,
        param: {
          ats_card_id: checkuserinfo.cardId,
          // ats_card_id: "3140207590757",
          token: token,
          channel: "OA",
          redirect_url: `${Configs.baseURL}/ats_waiting`,
        },
        bankCode: "kbank",
        bankID: bankIDKbank.Id,
      },
    };
    if (!requestBankMapping[bankID]) {
      return;
    }
    await checkATS(requestBankMapping[bankID]);
  };
  const getAtsApi = async (requestBankMapping) => {
    const f7_bank_ats = await listBank.find((o) =>
      o.Id.includes(requestBankMapping.bankID),
    );
    setIsLoading(true);
    //call ats
    try {
      GlobalApi.post(requestBankMapping.url, requestBankMapping.param, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.IsSuccess) {
            const registerRequestData = {
              bankCode: requestBankMapping.bankCode,
              ats_link: res.data.ats_link,
              ats_ref: res.data.ats_ref,
              ats_card_id: res.data.ats_card_id,
              BankId: requestBankMapping.bankID,
              textAccount: textAccount,
            };
            // let bankURL = registerRequestData.ats_link;
            // try {
            //   window.open(bankURL, "_blank").focus();
            // } catch (e) {
            //   if (browserName == "Mobile Safari") {
            //     setIsModalError(true);
            //     setModalErrorTitle(`ไม่สามารถดำเนินการต่อได้`);
            //     setModalErrorDes(
            //       "กรุณาตั้งค่าอนุญาตการเข้าถึง Pop-ups ที่เมนู ตั้งค่า (Settings) > Safari > ปิดกั้นหน้าต่างที่แสดงขึ้น (Block Pop-ups) เลื่อนปุ่มเพื่อเปลี่ยนจากสีเขียวเป็นสีเทา"
            //     );
            //     return;
            //   } else if (browserName == "Safari") {
            //     setIsModalError(true);
            //     setModalErrorTitle(`ไม่สามารถดำเนินการต่อได้`);
            //     setModalErrorDes(
            //       "กรุณาตั้งค่าอนุญาตการเข้าถึง Pop-ups ที่ Safari เลือก Preferences > Websites > Pop-ups และคลิก Allow"
            //     );
            //     return;
            //   }
            //   return;
            // }
            storeData("f7_bank_ats", f7_bank_ats);
            storeData("registerRequestData", registerRequestData);
            props.history.push("/ats_waiting");
          } else {
            // console.log("get ats fail", res.data.MsgDesc.return_message);
            setIsLoading(false);
            let title = "เกิดข้อผิดพลาด";
            let error_txt = res?.data?.MsgDesc?.return_message
              ? res?.data?.MsgDesc?.return_message
              : "";
            let mss =
              "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                error_txt !==
              ""
                ? error_txt
                : getData("api_error")?.message + ")";
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
            return false;
          }
        })
        .catch((er) => {
          // console.log(er);
          // console.log("get ats  error");
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
          return false;
        });
    } catch (error) {
      // console.log(error);
      // console.log("catch get ats error");
      setIsLoading(false);
      setIsModalError(true);
      return false;
    }
  };
  const saveComeback = async () => {
    setIsLoading(true);
    const atsdata = {
      f7_isother: "1",
      add_account_json: [
        {
          SAfba_Id: "0", //  fix เป็นค่า 0
          SAfba_SAmbk_Id: BankId.Id, // "BankId"
          SAfba_SAmbkb_Id: "", // "BranchId" เพิ่มใหม่ ส่ง 0
          SAfba_SAmbkt_Id: "", // เลขidของ ประเภทบัญชี ส่งค่าว่าง
          SAfba_AccountNo: textNumberBank, // "BankAccountNo"
          SAfba_AccountName: textAccount,
          SAfba_UseATS: "1", // ATSFlag ให้ตัดเงินด้วย ATS หรือไม่ใช่“1” ไม่ใช่“0”
          SAfba_UseDividend: "0", // fix เป็นค่า 0
        },
      ],
    };
    const f7_bank_ats = BankId;
    await saveImage();
    // console.log(stampUpload);
    await storeData("f7_ats", atsdata);
    await storeData("f7_bank_ats", f7_bank_ats);
    await storeData("stamp_page", "SUMMARY");
    var last_stamp = JSON.stringify(await getAllStorage("SUMMARY"));
    let uploadImageBook = await addWarterMarker(imgAccount, false, "");
    const saveData = [
      {
        name: "save ats",
        url: `${Configs.baseAPIURL03}/form/bank_account/manp`,
        postData: {
          head_token: head_token,
          f7_isother: atsdata.f7_isother,
          add_account_json: atsdata.add_account_json,
        },
      },
      {
        name: "upload bookbank",
        url: `${Configs.baseAPIURL03}/form/document/upload/bookbank`,
        postData: {
          head_token: head_token,
          id: "0",
          image_base64: uploadImageBook,
        },
      },
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "SUMMARY",
        },
      },
    ];
    setIsLoading(true);
    for (let i = 0; i < saveData.length; i++) {
      try {
        await GlobalApi.post(saveData[i].url, saveData[i].postData, header)
          .then(async (res) => {
            if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
              let mss =
                res.data.Data[0].MsgDesc !== ""
                  ? res.data.Data[0].MsgDesc
                  : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
              let title = "เกิดข้อผิดพลาด";
              clearData("f7_ats");
              clearData("uploadImageBookBank");
              setIsLoading(false);
              setIsModalError(true);
              setModalErrorTitle(title);
              setModalErrorDes(mss);
            } else {
              // console.log("save" + saveData[i].name + "  success");
              if (saveData[i].name === "upload bookbank") {
                // await clearData("uploadImageBookBank");
              }
              if (i === saveData.length - 1) {
                setIsLoading(false);
                await storeData("saveComebackComplete", true);
                props.history.push("/summary");
              }
            }
          })
          .catch((er) => {
            // console.log(er);
            // console.log("save " + saveData[i].name + "  error");
            i = saveData.length;
            clearData("f7_ats");
            clearData("uploadImageBookBank");
            setIsLoading(false);
            let title = "เกิดข้อผิดพลาด";
            let mss =
              "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
              getData("api_error")?.message +
              ")";
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          });
      } catch (error) {
        // console.log(error);
        clearData("f7_ats");
        clearData("uploadImageBookBank");
        i = saveData.length;
        // console.log("catch" + saveData[i].name + "  error");
        setIsLoading(false);
        setIsModalError(true);
      }
    }
  };
  const clickBack = async (requestBankMapping) => {
    const back_from_ats_apply = getData("back_from_ats_apply")
      ? getData("back_from_ats_apply")
      : "";
    const f7_ats = getData("f7_ats") ? getData("f7_ats") : "";
    if (!f7_ats) {
      clearData("uploadImageBookBank");
    }
    if (back_from_ats_apply) {
      clearData("back_from_ats_apply");
      props.history.push("/ats_list");
    } else {
      storeData("back_form_ats", true);
      props.history.push("/attach_sign");
    }
  };
  const popUps = (e) => {
    clearData("requestBankMapping");
    props.history.push("/summary");
  };
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.ats?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <DialogCustoms
            open={isModalATS}
            isModel={setIsModalATS}
            imgModalSuccess
            massage={massage}
            switchType={(e) => popUps(e)}
            title={"ข้อมูลสมัครบริการหักบัญชีอัตโนมัติ (ATS)"}
            btnPrimary={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.ats}
                        clickBack={(e) => clickBack()}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.ats?.title}
                          />
                          <ScrollBarComponent
                            isCheck={isCheck}
                            onChangeCheck={setIscheck}
                            content={
                              <Box>
                                <div className="font-title font-normal font-20  font-DBHeavent">
                                  การเปิดบัญชีออนไลน์กับ DAOL SEC
                                  ท่านยินยอมให้สมัครบริการหักบัญชีอัตโนมัติ
                                  (ATS) สำหรับหักเงินค่าซื้อ รับเงินปันผล
                                  รับเงินค่าขาย และถอนเงินจากบัญชีลงทุน
                                  ของทุนผลิตภัณฑ์ของบริษัท ตามธนาคารที่ท่านเลือก
                                </div>
                                <div className="font-title font-normal font-18  font-DBHeavent mt-3">
                                  หมายเหตุ: หากต้องการใช้บริการ DAOL SEC Wealth
                                  Advice กรุณาเลือกธนาคารกสิกรไทย
                                  หรือธนาคารไทยพาณิชย์เท่านั้น
                                </div>
                                <Typography className="font-title font-20">
                                  กรุณาเลือกธนาคารเพื่อสมัคร ATS Online
                                </Typography>

                                <Grid className="pt-4 pb-4">
                                  <FormControl
                                    component="fieldset"
                                    className={classes.BtnRadioAtsApply}
                                  >
                                    <RadioGroup
                                      aria-label="gender"
                                      name="controlled-radio-buttons-group"
                                      value={valueRadio}
                                      onChange={handleChangeRadio}
                                    >
                                      <div className={classes.btnRadioMain}>
                                        <FormControlLabel
                                          value="1"
                                          control={<Radio />}
                                          label="ธนาคารกสิกรไทย"
                                        />
                                        <img
                                          className={classes.iconBank}
                                          src={"images/Bank_KBANK.svg"}
                                        />
                                        <Divider />
                                        <div className={classes.subList}>
                                          <div className="li">
                                            <FiberManualRecordIcon />
                                            <span>
                                              กรอกข้อมูลหน้าเว็บ
                                              โดยท่านต้องอนุญาตให้ใช้ Pop-ups
                                            </span>
                                          </div>
                                          <div className="li">
                                            <FiberManualRecordIcon />
                                            <span>
                                              ยืนยันการผูกบัญชีที่ K PLUS
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className={classes.btnRadioMain}>
                                        <FormControlLabel
                                          value="0"
                                          control={<Radio />}
                                          label="ธนาคารไทยพาณิชย์"
                                        />
                                        <img
                                          className={classes.iconBank}
                                          src={"images/Bank_SCB.png"}
                                        />
                                        <Divider />
                                        <div className={classes.subList}>
                                          <div className="li">
                                            <FiberManualRecordIcon />
                                            <span>
                                              กรอกข้อมูลหน้าเว็บ โดยท่านต้อง
                                              อนุญาตให้ใช้ Pop-ups
                                            </span>
                                          </div>
                                          <div className="li">
                                            <FiberManualRecordIcon />
                                            <span>
                                              ยืนยันการผูกบัญชีที่ SCB Easy
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <Typography className="font-title font-20 pb-4">
                                        หรือกรอกข้อมูลบัญชีธนาคารเพื่อการทำธุรกรรม
                                        / สมัคร ATS ภายหลัง
                                      </Typography>
                                      <div className={classes.btnRadioMain}>
                                        <FormControlLabel
                                          className={"radioOther"}
                                          value="99"
                                          control={<Radio />}
                                          label="กรุณาเลือกธนาคาร"
                                        />
                                        {/* <Divider />
                                        <div className={classes.subList}>
                                          <div className="li">
                                            <span>
                                              กรอกข้อมูลบัญชีธนาคารเพื่อการทำธุรกรรม
                                              / สมัคร ATS ภายหลัง
                                            </span>
                                          </div>
                                        </div> */}
                                      </div>
                                    </RadioGroup>
                                  </FormControl>
                                  {valueRadio === "99" && (
                                    <Box>
                                      <Grid className="input-form">
                                        <FormControl
                                          variant="standard"
                                          fullWidth
                                          error
                                        >
                                          <Autocomplete
                                            options={listBank}
                                            value={BankId}
                                            getOptionLabel={(option) =>
                                              option.ThName ? option.ThName : ""
                                            }
                                            onChange={(e, value) =>
                                              handleChangeBank(e, value)
                                            }
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                InputProps={{
                                                  ...params.InputProps,
                                                  readOnly: true,
                                                }}
                                                variant="standard"
                                                label="ธนาคาร"
                                                required
                                              />
                                            )}
                                          />
                                        </FormControl>
                                      </Grid>
                                      <Grid className="input-form">
                                        <FormControl
                                          variant="standard"
                                          fullWidth
                                          error
                                        >
                                          <TextField
                                            fullWidth
                                            className={"font-20"}
                                            label="ชื่อบัญชีธนาคาร"
                                            variant="standard"
                                            value={textAccount}
                                            onChange={(e) =>
                                              textAccountChange(e.target.value)
                                            }
                                            disabled
                                            required
                                          />
                                        </FormControl>
                                      </Grid>
                                      <Grid className="input-form">
                                        <FormControl
                                          variant="standard"
                                          fullWidth
                                          error
                                        >
                                          <TextField
                                            fullWidth
                                            className={"font-20"}
                                            label="หมายเลขบัญชีธนาคาร"
                                            variant="standard"
                                            value={fomaterBankNumber(
                                              textNumberBank,
                                            )}
                                            onChange={(e) =>
                                              textNumberBankChange(
                                                e.target.value,
                                              )
                                            }
                                            type="tel"
                                            inputProps={{
                                              maxLength: 10,
                                            }}
                                            error={errorText?.textNumberBank}
                                            required
                                          />
                                          <FormHelperText className="text-error text-right">
                                            {errorText?.textNumberBank}
                                          </FormHelperText>
                                        </FormControl>
                                      </Grid>
                                      <Typography
                                        className="font-title font-20"
                                        sx={{ pt: 3 }}
                                      >
                                        ภาพสมุดบัญชีธนาคาร หน้าแรก
                                      </Typography>
                                      <Grid className="pt-4 pb-4">
                                        {/* <label htmlFor="contained-button-file"> */}
                                        {/* <Box className={classes.borderCustom}> */}
                                        <Grid>
                                          <Grid
                                            className="image-snap-card"
                                            style={{
                                              backgroundImage:
                                                "url(" +
                                                imgAccountWithWaterMark +
                                                ")",
                                            }}
                                          >
                                            <label htmlFor="contained-button-file">
                                              <Input
                                                accept="image/png, image/jpeg"
                                                id="contained-button-file"
                                                multiple
                                                onChange={upLoadOnChange}
                                                onClick={(event) => {
                                                  event.target.value = null;
                                                }}
                                                type="file"
                                              />
                                              <Button
                                                component="span"
                                                className={clsx(
                                                  "btn-snap-card-bank",
                                                )}
                                              >
                                                <CardMedia
                                                  style={{
                                                    display:
                                                      imgAccountWithWaterMark
                                                        ? "none"
                                                        : "block",
                                                  }}
                                                  component="img"
                                                  className="icon-photo"
                                                  image="../../images/photo.png"
                                                  alt="photo"
                                                />
                                              </Button>
                                              <Grid
                                                className="text-snap-card font-20 font-DBHeavent text-primary"
                                                style={{
                                                  display:
                                                    imgAccountWithWaterMark
                                                      ? "none"
                                                      : "",
                                                }}
                                              >
                                                เพิ่มรูปภาพสมุดบัญชีหน้าแรก
                                              </Grid>
                                            </label>
                                          </Grid>
                                          <Grid>
                                            <CardMedia
                                              style={{
                                                display: imgAccountWithWaterMark
                                                  ? "block"
                                                  : "none",
                                              }}
                                              component="img"
                                              className="icon-photo-water-book"
                                              image="../../images/waterMark2.png?v=4"
                                              alt="photo"
                                            />
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  )}
                                </Grid>
                                {/* ✅ เพิ่มช่องว่างท้ายสุดของ content */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    height: 50,
                                  }}
                                />
                              </Box>
                            }
                          ></ScrollBarComponent>{" "}
                          <ButtonRight
                            isDisbled={checkOthorValidate() || !valueRadio}
                            text={translations?.[lang]?.ats?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(AtsApply);
